module.exports = __webpack_public_path__ + "static/media/black.894edc11.png";